const handleDeleteFormActions = {
  confirm: '¿Realmente quiere eliminar esta acción?',
  title: 'ELIMINAR ACCIÓN'
};

export default handleDeleteFormActions;
